export const DOGMA_SOURCES = {
  catechismMary: "https://www.vatican.va/archive/ENG0015/__P1K.HTM",
  catechismChurch: "https://www.vatican.va/archive/ENG0015/__P2C.HTM",
  lumenGentium: "https://www.vatican.va/archive/hist_councils/ii_vatican_council/documents/vat-ii_const_19641121_lumen-gentium_en.html",
  ineffabilis: "https://www.vatican.va/content/pius-ix/it/documents/18541208-costituzione-apostolica-ineffabilis-deus.html",
  ineffabilisEnglish: "https://www.newadvent.org/library/docs_pi09id.htm",
  assumption: "https://www.vatican.va/content/pius-xii/en/apost_constitutions/documents/hf_p-xii_apc_19501101_munificentissimus-deus.html",
  ephrem: "https://www.vatican.va/content/benedict-xvi/en/audiences/2007/documents/hf_ben-xvi_aud_20071128.html",
  scotus: "https://www.vatican.va/content/benedict-xvi/en/audiences/2010/documents/hf_ben-xvi_aud_20100707.html",
  irenaeus: "https://www.newadvent.org/fathers/0103322.htm",
  ignatius: "https://www.newadvent.org/fathers/0104.htm",
  jerome: "https://www.newadvent.org/fathers/3007.htm",
  damascene: "https://www.newadvent.org/fathers/33044.htm",
  aquinasMother: "https://www.newadvent.org/summa/4035.htm#article4",
  aquinasVirgin: "https://www.newadvent.org/summa/4028.htm",
  aquinasSanctification: "https://www.newadvent.org/summa/4027.htm#article2",
  cyril: "https://www.newadvent.org/fathers/3810.htm",
  leo: "https://www.newadvent.org/fathers/3604028.htm",
};